import supabase from "artifact/supabase";
import Form, { style } from "element/form";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";

@define("m-sign-out")
class SignUp extends Form {
  @connected
  @paint
  [trait.template]() {
    return `
      <form class='${style.form}' novalidate>
        <button class='${style.form__button}'>Sair</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  async [trait.onSubmit]() {
    await supabase.auth.signOut();
    location.assign("/oauth/sign-in");
    return this;
  }
}

export default SignUp;
